import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiFileText, FiLock, FiInfo } = FiIcons;

const Legal = () => {
  const [activeTab, setActiveTab] = useState('privacy');

  const content = {
    privacy: {
      title: "Privacy Policy",
      content: "At HDAI Software, we prioritize patient confidentiality and developer privacy above all. Our 'Privacy-First' architecture ensures that clinical data never touches our servers unless explicitly requested by the user through our secure Vault module. We are fully HIPAA and GDPR compliant."
    },
    terms: {
      title: "Terms of Service",
      content: "By using the HDAI Software platform, you agree to our clinical safety guidelines. Our software is a Clinical Decision Support (CDS) tool and is intended for use by qualified medical professionals. It does not replace clinical judgment."
    },
    nda: {
      title: "Non-Disclosure Agreement",
      content: "All clinical logic developed on HDAI Software is the intellectual property of the creator. We provide a 'Zero-Knowledge' development environment where your proprietary algorithms (.hd files) remain encrypted and inaccessible to HDAI personnel."
    }
  };

  return (
    <div className="pt-24 pb-20 bg-brand-ivory min-h-screen">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-white rounded-[3rem] border border-gray-100 shadow-xl overflow-hidden">
          <div className="bg-brand-indigo p-12 text-center text-white">
            <h1 className="text-4xl font-display font-bold mb-4">Legal Hub</h1>
            <p className="text-white/60">Transparency, Security, and Compliance.</p>
          </div>
          
          <div className="flex border-b border-gray-100 overflow-x-auto">
            {Object.keys(content).map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`flex-1 py-6 px-4 text-sm font-bold uppercase tracking-widest transition-all ${activeTab === tab ? 'text-brand-indigo border-b-2 border-brand-indigo bg-brand-mint/5' : 'text-gray-400 hover:text-brand-indigo'}`}
              >
                {tab === 'nda' ? 'NDA' : tab}
              </button>
            ))}
          </div>

          <div className="p-12">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              className="space-y-8"
            >
              <div className="flex items-center space-x-4 mb-8">
                <div className="w-12 h-12 bg-brand-mint/20 rounded-2xl flex items-center justify-center">
                  <SafeIcon icon={activeTab === 'privacy' ? FiShield : activeTab === 'terms' ? FiFileText : FiLock} className="text-brand-indigo text-xl" />
                </div>
                <h2 className="text-3xl font-bold text-brand-indigo">{content[activeTab].title}</h2>
              </div>
              
              <div className="prose prose-indigo max-w-none text-brand-slate leading-relaxed">
                <p className="text-lg mb-6">{content[activeTab].content}</p>
                <h3 className="text-xl font-bold text-brand-indigo mb-4">Key Provisions</h3>
                <ul className="space-y-4">
                  <li className="flex items-start space-x-3">
                    <SafeIcon icon={FiInfo} className="mt-1 text-brand-mint" />
                    <span>Data processing occurs locally whenever possible via the --local flag.</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <SafeIcon icon={FiInfo} className="mt-1 text-brand-mint" />
                    <span>End-to-end encryption for all .hdpkg files in the Marketplace.</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <SafeIcon icon={FiInfo} className="mt-1 text-brand-mint" />
                    <span>Automatic audit log generation for all clinical inferences.</span>
                  </li>
                </ul>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Legal;